<template>
  <li class="navigation-list-item" v-on:mouseenter="showSubNav(true)" v-on:mouseleave="showSubNav(false)">
    <a
      v-if="navUrl"
      :id="id"
      :class="`navigation-link toggle-sub-navigation ${isActive ? 'RouterLink-active' : ''}`"
      :href="navUrl"
      @click.prevent="openNavLink($event, navUrl)"
      @keydown.enter.prevent="handleKeydown($event, navUrl)"
      tabindex="0"
      :aria-current="isActive ? 'true' : undefined"
    >
      <span @click.prevent="openNavLinkMobile(navUrl)">{{ name }}</span>
      <i
        @click.prevent="toggleSubNavMobile()"
        @keydown.enter.prevent="toggleSubNavMobile()"
        @keydown.space.prevent="toggleSubNavMobile()"
        class="sub-nav-arrow icon-chevron-down"
        v-if="!isStaticLink"
        tabindex="0"
        role="button"
        :aria-label="ariaLabel"
        :aria-controls="`navigaatio-${id}`"
        :aria-expanded="isOpen"
      ></i>
    </a>
    <div
      v-else
      :class="`navigation-link navigation-link-hoverable toggle-sub-navigation ${isActive ? 'RouterLink-active' : ''}`"
    >
      <span>{{ name }}</span>
      <i @click.prevent="toggleSubNavMobile()" class="sub-nav-arrow icon-chevron-down" v-if="!isStaticLink"></i>
    </div>
    <div :class="getSubNavClass()">
      <ul :id="`navigaatio-${id}`">
        <navigation-subnav-item
          v-for="route in routes"
          :key="`route-path-${route.id}`"
          :id="route.id"
          :name="route.name"
          :href="route.path"
          :externalLink="route.external || false"
          :isOpen="isOpen"
        ></navigation-subnav-item>
      </ul>
    </div>
  </li>
</template>
<script>
import isMobile from '@/utils/isMobile';
import NavigationSubnavItem from './navigation-subnav-item.vue';
import utils from '@/app/utils/utils';
import useSafeRoute from '@/app/composables/useSafeRoute';

export default {
  name: 'navigation-subnav',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    navUrl: {
      type: String,
      required: false,
    },
    routes: {
      required: false,
      type: Array,
    },
    pathRef: {
      type: String,
      required: true,
    },
    isStaticLink: {
      type: Boolean,
      required: false,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
    weAreInMobile: false,
  }),
  methods: {
    getSubNavClass() {
      return this.isOpen && !this.isStaticLink ? 'sub-navigation is-visible' : 'sub-navigation';
    },
    openNavLink(event, href, forcedNavigation = false) {
      event.preventDefault();
      if (!this.weAreInMobile || forcedNavigation) {
        this.$bus.$emit('openMainNavLink', { href });
      }
    },
    handleKeydown(event, href) {
      if (event.key === 'Enter' && event.target.tagName === 'A') {
        this.openNavLink(event, href, true);
      }
    },
    showSubNav(showSubNav) {
      if (!this.weAreInMobile) {
        this.isOpen = showSubNav;
      }
    },
    openNavLinkMobile(href) {
      this.$bus.$emit('openMainNavLink', { href });
    },
    toggleSubNavMobile() {
      if (!this.isOpen) {
        this.$bus.$emit('collapseExpanders');
      }
      this.isOpen = !this.isOpen;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isOpen = false;
      }
    },
  },
  computed: {
    isActive() {
      return (
        this.route.path === this.navUrl ||
        this.route.path.includes(this.pathRef) ||
        (this.routes && this.routes.some((r) => this.route.path.includes(utils.stripQuery(r.path))))
      );
    },
  },
  components: {
    NavigationSubnavItem,
  },
  mounted() {
    this.weAreInMobile = isMobile();
    this.$bus.$on('windowResized', () => {
      this.isOpen = false;
      this.weAreInMobile = isMobile();
    });

    this.$bus.$on('collapseExpanders', () => {
      this.isOpen = false;
    });

    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>
